import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import CommunityFeatures from './components/CommunityFeatures';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '文爱社区 - 文字情感交流平台首页',
    description: '文爱社区是专注于文字情感表达与互动的高品质社区平台，汇聚热爱文字交流的用户。分享心声、寻找共鸣、体验文字带来的温度与浪漫。',
    url: 'https://luckilypink.com.cn',
    isPartOf: {
      '@type': 'WebSite',
      name: '文爱社区',
      url: 'https://luckilypink.com.cn',
    },
  };

  return (
    <>
      <SEOHead
        title="文爱社区 - 高质量文字情感交流平台"
        description="文爱社区是专注于文字情感表达与互动的高品质社区平台，汇聚热爱文字交流的用户。在这里分享心声、寻找共鸣、体验文字带来的温度与浪漫。加入文爱社区，感受文字的力量。"
        keywords="文爱社区,文字情感社区,文爱交流平台,文字互动社区,情感文字分享,文爱聊天社区"
        canonicalUrl="https://luckilypink.com.cn"
        ogTitle="文爱社区 - 高质量文字情感交流平台"
        ogDescription="文爱社区是专注于文字情感表达与互动的高品质社区平台，汇聚热爱文字交流的用户。"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <CommunityFeatures />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}